<script lang="ts">
	import StickyHeader from '$lib/components/display/StickyHeader.svelte'
	import type { PublicReviewFieldsFragment } from '$src/lib/queries/fragments/generated/ReviewFields'
	import Review from './Review.svelte'

	interface Props {
		reviews: PublicReviewFieldsFragment[]
	}

	let { reviews }: Props = $props()
</script>

<!-- <StickyHeader class="w-full mb-4 top-[64px] lg:top-16" title="Reviews" /> -->

{#each reviews as review}
	<Review {review} />
{/each}
